<template>
  <div class="mx-auto w-full text-center tracking-wide">
    <h3 class="h4">{{ flowGroup.name }}</h3>
    <p>{{ flowGroup.description }}</p>
  </div>
</template>

<script>
export default {
name: "FlowGroup",

  props: {
    flowGroup: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
